import { User } from '@/domain/types/user';

/**
 * Convierte un documento de `users` en un User. El ID real del documento va al
 * final para que no lo pise un campo `id` guardado dentro de los datos (algunos
 * usuarios tienen ahí su número de documento): con ese valor, updateDoc
 * apuntaría a un documento inexistente y la escritura fallaría con not-found.
 */
export function userFromDoc(snapshot: {
  id: string;
  data: () => Record<string, unknown>;
}): User {
  return { ...snapshot.data(), id: snapshot.id } as User;
}
